function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

import { compose } from 'redux';

/* eslint-disable import/prefer-default-export */
export var curry = function curry(fn) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    return fn.length <= args.length ? fn.apply(undefined, args) : function () {
        for (var _len2 = arguments.length, more = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            more[_key2] = arguments[_key2];
        }

        return curry.apply(undefined, [fn].concat(args, more));
    };
};

export var pipe = function pipe() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
    }

    return compose.apply(undefined, _toConsumableArray(args.reverse()));
};